import { createSlice } from "@reduxjs/toolkit"
import locationApiSlice from "services/locationApiSlice"
import providersApiSlice from "services/providerApiSlice"
import * as _ from "lodash"

const filter = (action) => {
  return [providerSlice.actions.setLocationSelected.type].includes(action.type)
}

const initialState = {
  locations: {
    locationList: [],
    selected: [],
    locationMap: {},
  },
  selectedLocations: [],
  canAddUser: true,
  providers: [],
  ids: [],
  providerMap: [],
  providersMap: {},
}

const providerSlice = createSlice({
  name: "providers",
  initialState,
  reducers: {
    addRemoveUser: (state, action) => {
      if (state.canAddUser) {
        state.providers.unshift({ _id: new Date().getTime(), userType: 1 })
        state.canAddUser = false
      } else {
        state.providers.shift()
        state.canAddUser = true
      }
    },
    setLocationSelected: (state, action) => {
      const locations = action.payload
      state.locations.selected = locations
    },
  },
  extraReducers: (builder) => {
    // builder.addMatcher(providersApiSlice.endpoints.addUser.matchFulfilled, (state, action) => {
    //     state.providers[0] = action.payload
    //     state.canAddUser = true
    //     sessionStorage.setItem('providers', JSON.stringify(state.providers))

    // })

    // builder.addMatcher(providersApiSlice.endpoints.deleteUser.matchFulfilled, (state, action) => {
    //     const deletedUsers = action.payload.deletedUsers;
    //     state.providers = state.providers.filter((user) => {
    //         return !deletedUsers.includes(user?._id);
    //     })
    // })

    builder.addMatcher(
      providersApiSlice.endpoints.fetchProviders.matchFulfilled,
      (state, action) => {
        state.providers = action.payload?.providers || []

        action.payload?.providers?.forEach((provider) => {
          state.providersMap[provider.providerid] = provider
          state.ids.push(provider.providerid)
        })
        sessionStorage.setItem("providers", JSON.stringify(action.payload))
      }
    )

    builder.addMatcher(
      providersApiSlice.endpoints.fetchProviders.matchRejected,
      (state, action) => {
        state.providers = []
        state.providersMap = {}
        state.ids = []
        sessionStorage.removeItem("providers")
      }
    )

    builder.addMatcher(
      providersApiSlice.endpoints.fetchLocations.matchFulfilled,
      (state, action) => {
        state.locations.locationList = action.payload
        state.locations.locationList?.forEach((location) => {
          state.locations.locationMap[location?._id] = location.name
        })
      }
    )

    builder.addMatcher(
      providersApiSlice.endpoints.fetchLocations.matchRejected,
      (state, action) => {
        state.locations.locationList = []
        state.locations.locationMap = {}
      }
    )

    builder.addMatcher(filter, (state, action) => {
      const providers = JSON.parse(sessionStorage.getItem("providers"))
      if (state.locations.selected?.length) {
        state.providers = providers.filter((user) => {
          return state.locations.selected.includes(user.locationId)
        })
      } else {
        state.providers = providers
      }
    })
  },
})

export default providerSlice.reducer
export const { addRemoveUser, setLocationSelected } = providerSlice.actions
